import emptySliceApi from '../../../shared/store/emptyApiSlice';

export interface UpdateDealSettingsApiRequest {
  accountId: string;
  payload: DealSettingPayload[];
}

export interface DealSettingPayload {
  dealId: string;
  enabled?: boolean;
  hidden?: boolean;
  reseller?: boolean;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateDealSettings: builder.mutation<void, UpdateDealSettingsApiRequest>({
      query: ({ accountId, payload }) => ({
        url: `v4/accounts/${accountId}/deals/settings`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Deal', 'AccountAlerts'],
    }),
    updateAccountSupportEmail: builder.mutation<
      void,
      { accountId: string; email: string }
    >({
      query: ({ accountId, email }) => ({
        url: `v4/accounts/${accountId}/contactemail`,
        method: 'PUT',
        body: { email },
      }),
      invalidatesTags: ['AccountData', 'Diagnostics'],
    }),
  }),
});

export const {
  useUpdateDealSettingsMutation,
  useUpdateAccountSupportEmailMutation,
} = apiSlice;
